import { Employee, Role } from './employeeShifts.types';

export enum EmployeeShiftPoolStatusEnum {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  ASSIGNED = 'Assigned',
}

export const StatusBackgroundColorMap: Record<string, string> = {
  [EmployeeShiftPoolStatusEnum.PENDING]: '#FFF4CC',
  [EmployeeShiftPoolStatusEnum.APPROVED]: '#E9F3EE',
  [EmployeeShiftPoolStatusEnum.DECLINED]: '#FAE4E1',
  [EmployeeShiftPoolStatusEnum.ASSIGNED]: '#E9F3EE',
};

export enum EmployeeShiftPoolTypeEnum {
  OPEN = 'Open',
  RELEASED = 'Released',
  SWAP = 'Swap',
}

export enum EmployeeShiftPoolTabEnum {
  REQUESTS = 'Requests',
  RELEASED = 'Released',
  MYOWN = 'My Own',
  PROCESSED = 'Processed',
}

export interface Shift {
  id: number;
  date: string;
  role: Role;
  type: string;
  endTime: string;
  employee?: Employee;
  shiftEnd: string | null;
  startTime: string;
  shiftHours?: number;
}

export interface ShiftPoolTypes {
  id?: number;
  type?: string;
  status?: EmployeeShiftPoolStatusEnum | string;
  createdAt?: string;
  shift?: Shift;
  swap?: {
    id?: number;
    swapToShift?: Shift;
    isApprovedByManager?: null | boolean;
    isApprovedBySwapToEmployee?: null | boolean;
  };
  totalBids?: string;
  bidded?: boolean;
}

export interface ShiftPoolBidsTypes {
  id: string;
  name: string;
  image: string | null;
  displayId: number;
  biddedAt: string; // ISO 8601 date string
  bidId: number;
  overtime: number;
  status: EmployeeShiftPoolStatusEnum;
}
